import * as amplitude from '@amplitude/analytics-browser';

import { tripActions } from 'wanderu-ducks-trips';
import Logger from 'wanderu-logger';
import WapiService from 'wanderu-service-wapi';
import { isLandingPage } from 'wanderu-utils';

import { actions as psearchActions } from '../../appstate';
import {
    buildSearchBody,
    formatTripResults,
    serializeSearchParams,
} from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-psearch:fetchAllTrips');

function fetch(opts, path = '') {
    return async (dispatch, getState) => {
        const working = selectors.selectWorking(getState(), opts);
        const success = selectors.selectSuccess(getState(), opts);

        if (working || success) {
            return;
        }

        dispatch(actions.startWork(opts));

        let error;
        let meta;
        let tripIds = [];

        const defaultSearchParams = {
            cached: true,
            jitted: true,
            routed: true,
        };

        // prefer opts that override default search params
        const searchParams = {
            ...defaultSearchParams,
            ...opts,
        };

        const body = buildSearchBody(searchParams);
        body.isSeoPage = isLandingPage(path);
        body.isWebApp = true;

        try {
            const {
                result,
                // eslint-disable-next-line no-shadow
                meta,
            } = await WapiService.post('psearch.json', { body });

            window?.DD_RUM?.stopDurationVital?.('jittedSearchResultsReturning');

            const trips = formatTripResults(result);

            dispatch(tripActions.setTrips(trips));

            const searchId = serializeSearchParams(opts);
            const batchId = body.batchId;
            tripIds = Object.keys(trips);

            const deviceId = amplitude.getDeviceId();
            const sessionId = amplitude.getSessionId();

            const context = {
                batchId,
                departDate: searchParams.departDatetime,
                destinationPlaceId: searchParams.destinationPlaceId,
                destinationText: searchParams.destinationText,
                deviceId,
                direction: searchParams.direction,
                jittedTripCount: tripIds?.length,
                originPlaceId: searchParams.originPlaceId,
                originText: searchParams.originText,
                returnDate: searchParams.returnDatetime,
                searchId,
                sessionId,
            };

            logger.event('fetch', context);

            // eslint-disable-next-line consistent-return
            return dispatch(psearchActions.setSearchResults(
                searchId,
                batchId,
                tripIds,
                meta.trips,
                true,
            ));
        } catch (ex) {
            logger.error('fetch', ex, body);
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };

            throw ex;
        } finally {
            dispatch(actions.endWork(opts, meta, error));

            const shouldRetryRouted = !tripIds.length && !searchParams.routed && searchParams.retryRouted;

            if (shouldRetryRouted) {
                dispatch(reset(searchParams));
                // eslint-disable-next-line no-unsafe-finally, consistent-return
                return dispatch(fetch({
                    ...searchParams,
                    routed: true,
                }));
            }
        }
    };
}

function reset(opts) {
    return actions.reset(opts);
}

const fetchAllTripsAction = {
    fetch,
    reset,
    ...selectors,
};

export {
    fetchAllTripsAction,
};

export default {
    [namespace]: reducer,
};
